import React, { Component, PropTypes } from 'react';
import { StoreOverviewActions, StripeActions } from 'actions';
import ItemDetails from 'components/Store/ItemDetails';
import Loader from 'components/Material/Loader';
import Constants from 'Constants';
import CountdownTimer from 'components/CountdownTimer';
import Css from 'Css';
import { history } from 'helpers';
const { Units, Colors } = Css;
import { TextField, RaisedButton } from 'material-ui';
import * as SvgIcons from 'components/Material/SvgIcons';

const isValidYear = /^[0-9]{4}$/;
const isValidCCNumber = /^[0-9]{16}$/;
const isValidMonth = /^[0-9]{2}$/;
const isValidCvC = /^[0-9]{3}$/;

const css = oxygenCss({
  root: {
    padding: Units.base
  },

  details: {
    padding: Units.base * 4
  },

  method: {
    textAlign: 'right',
    '>DIV': {
      display: 'inline-block',
      width: 128,
      textAlign: 'left'
    }
  },
  container: {
    padding: Units.base
  },
  flex: {
    display: 'flex',
    padding: Units.base / 2
  },
  flexChild: {
    padding: Units.base / 2,
    flex: '1'
  },
  courseBought: {
    textAlign: 'center',
    padding: Units.keyline
  },
  error: {
    fontSize: '18px',
    display: 'inline',
    color: '#FF3030'
  },
  secure3DFrame: {
    width: '100%',
    height: 500
  }
});

class StripeCheckoutForm extends Component {
  static propTypes = {
    exp_month: PropTypes.string,
    exp_year: PropTypes.string,
    number: PropTypes.string,
    cvc: PropTypes.string,
    error: PropTypes.string,
    errorText: PropTypes.object,
    paymentLoading: PropTypes.bool,
    paymentComplete: PropTypes.bool
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func,
    muiTheme: PropTypes.object,
    router: PropTypes.object
  };

  state = {
    errorText: {}
  };

  stripeSecure3DSuccess = event => {
    const { detail } = event;
    StoreOverviewActions.completePayment(
      null,
      Constants.paymentProviders.STRIPE
    );
  };

  componentWillMount() {
    window.document.addEventListener(
      'stripeSecure3DSuccess',
      this.stripeSecure3DSuccess,
      false
    );
  }

  componentWillUnmount() {
    window.document.removeEventListener(
      'stripeSecure3DSuccess',
      this.stripeSecure3DSuccess
    );
  }

  changePropertyWithEvent(property, event) {
    const { value } = event.target;
    StripeActions.change({
      [property]: value
    });
    StoreOverviewActions.clearError();
  }

  change(property, value) {
    StripeActions.change({
      [property]: value
    });
    StoreOverviewActions.clearError();
  }

  redirect = () => {
    if (this.props.loggedIn) {
      history.push(`/dashboard`);
    } else {
      StoreOverviewActions.reset();
    }
  };

  completePurchase = () => {
    StoreOverviewActions.startPayment(
      Constants.paymentProviders.STRIPE,
      null,
      null,
      null,
      null
    );
  };

  renderForm() {
    const { paymentLoading } = this.props;
    const { getIntlMessage } = this.context;
    return (
      <div className={css.details}>
        <div className={css.container}>
          {paymentLoading && <Loader />}
          {!paymentLoading && (
            <RaisedButton
              style={{
                left: '50%',
                position: 'relative',
                transform: 'translateX(-50%)'
              }}
              secondary
              label={getIntlMessage('payment.payWithStripe')}
              onTouchTap={this.completePurchase}
            />
          )}
        </div>
      </div>
    );
  }

  back = () => {
    StoreOverviewActions.setPaymentMethod(null);
  };

  render() {
    const { error, paymentComplete, cart, loading, ...other } = this.props;
    const [item] = cart;
    let detail;
    if (loading) {
      detail = <Loader />;
    } else {
      if (paymentComplete) {
        detail = (
          <div className={css.courseBought}>
            <CountdownTimer
              seconds={2}
              color='#777'
              alpha={0.3}
              size={128}
              onComplete={this.redirect}
            />
            <br />
            {this.context.getIntlMessage('store.purchaseSuccess')}
          </div>
        );
      } else {
        detail = this.renderForm();
      }
    }

    return (
      <div>
        <ItemDetails {...item} />
        {error && (
          <div className={css.courseBought}>
            <div className={css.error}>{error}</div>
          </div>
        )}
        {detail}
      </div>
    );
  }
}

export default StripeCheckoutForm;



// WEBPACK FOOTER //
// ./src/js/components/Store/StripeCheckoutForm.js